var CourseEngineEnum;
(function (CourseEngineEnum) {
    CourseEngineEnum["COLLECTIVITY"] = "collectivity";
    CourseEngineEnum["UN_JEUNE_UNE_SOLUTION"] = "1j1s";
})(CourseEngineEnum || (CourseEngineEnum = {}));

var LegalPageType;
(function (LegalPageType) {
    LegalPageType["ACCESSIBILITY"] = "accessibility";
    LegalPageType["CGU"] = "cgu";
    LegalPageType["CONFIDENTIALITE"] = "confidentialite";
    LegalPageType["MENTIONS"] = "mentions-legales";
})(LegalPageType || (LegalPageType = {}));

var LegalPageStatus;
(function (LegalPageStatus) {
    LegalPageStatus["ONLINE"] = "online";
    LegalPageStatus["DRAFT"] = "draft";
})(LegalPageStatus || (LegalPageStatus = {}));

/**
 * Generated bundle index. Do not edit.
 */

export { CourseEngineEnum, LegalPageStatus, LegalPageType };

